import { z } from "zod";
import { Survey_ConnectPaywall, Survey_Create, Survey_Delete, Survey_DiscconnectPaywall, Survey_ViewStats } from "./surveys";
import { Documentation_Click } from "./docs";
import { Paywall_Create, Paywall_Preview, Paywall_Update } from "./paywall";
import { Chart_Download, Chart_TimeframeChange, Chart_View } from "./chart";
import { Campaign_ChartView, Campaign_Create, Campaign_RuleAdd, Campaign_RuleUpdate, Campaign_TriggerUpdate, Campaing_VariantUpdate } from "./campaign";
import { GroupReference } from "./group";
import { Onboarding_AddProductToPaywall, Onboarding_Complete, Onboarding_PaywallPresent, Onboarding_ProductCreate, Onboarding_ProductionTransactionComplete, Onboarding_PurchaseComplete, Onboarding_SDKInstall } from "./onboarding";
import { DemoRequest_Begin, DemoRequest_Submit, DemoRequest_Visit, SignUp_Begin, User_AcceptInvite, User_LogIn, User_LogOut, User_SignUp } from "./auth";
import { Team_MemberInvite } from "./team";
import { Localization_ProviderAddedOrUpdated, Localization_ProviderRemoved, Localization_FileDownload, Localization_FileUpload } from "./localization";
import { Application_Create, Application_Delete } from "./application";
import { Project_AssignApplication, Project_Create, Project_Delete, Project_RemoveApplication } from "./project";
export const AnalyticsEvent = z.discriminatedUnion("name", [
    // Charts
    Chart_View,
    Chart_Download,
    Chart_TimeframeChange,
    // Application
    Application_Create,
    Application_Delete,
    // Surveys
    Survey_Create,
    Survey_Delete,
    Survey_ConnectPaywall,
    Survey_DiscconnectPaywall,
    Survey_ViewStats,
    // Users
    User_SignUp,
    User_LogIn,
    User_LogOut,
    User_AcceptInvite,
    // Unauthenticated
    DemoRequest_Begin,
    DemoRequest_Visit,
    DemoRequest_Submit,
    SignUp_Begin,
    // Onboarding
    Onboarding_SDKInstall,
    Onboarding_PaywallPresent,
    Onboarding_PurchaseComplete,
    Onboarding_ProductCreate,
    Onboarding_AddProductToPaywall,
    Onboarding_ProductionTransactionComplete,
    Onboarding_Complete,
    // Team
    Team_MemberInvite,
    // Localization
    Localization_FileUpload,
    Localization_FileDownload,
    Localization_ProviderAddedOrUpdated,
    Localization_ProviderRemoved,
    // Documentation
    Documentation_Click,
    // Paywalls
    Paywall_Create,
    Paywall_Update,
    Paywall_Preview,
    // Projects
    Project_Create,
    Project_AssignApplication,
    Project_RemoveApplication,
    Project_Delete,
    // Campaigns
    Campaign_Create,
    Campaign_TriggerUpdate,
    Campaign_RuleUpdate,
    Campaign_RuleAdd,
    Campaing_VariantUpdate,
    Campaign_ChartView
]);
export { GroupReference };
